import React from 'react';
import classNames from 'classnames';
import { Disclosure } from '@headlessui/react';
import { SvgIconComponent } from '../types/svgs';
import { ChevronDownIcon } from '@heroicons/react/outline';

const CollapseableContainer: React.FC<{
  title: string | React.ReactNode;
  Icon?: SvgIconComponent;
  children: React.ReactNode;
  className?: string;
  defaultOpen?: boolean;
  ButtonComponent?: React.ReactNode;
  dragAttributes?: React.HTMLAttributes<HTMLElement>;
  dragListeners?: Record<string, any>;
  TitleLeftComponent?: React.ReactNode;
}> = ({
  title,
  Icon,
  children,
  className,
  defaultOpen = true,
  ButtonComponent,
  dragAttributes,
  dragListeners,
  TitleLeftComponent,
}) => {
  return (
    <Disclosure
      as="div"
      className={classNames(
        'relative min-w-0 overflow-hidden rounded-xl border border-neutral-75 bg-white',
        className,
      )}
      defaultOpen={defaultOpen}
    >
      {({ open }) => (
        <>
          <Disclosure.Button
            {...dragAttributes}
            {...dragListeners}
            className={classNames(
              'flex w-full items-center justify-between',
              !ButtonComponent ? 'p-5' : 'px-5 py-3.5',
              dragListeners && 'cursor-grab active:cursor-grabbing',
            )}
          >
            <div className="flex items-center space-x-3">
              {TitleLeftComponent && TitleLeftComponent}
              {Icon && <Icon className="h-5 w-5 text-neutral-125" />}
              <div className="text-body font-medium text-neutral-150">
                {title}
              </div>
            </div>
            <div className="flex flex-row items-center justify-end">
              {ButtonComponent && ButtonComponent}
              <ChevronDownIcon
                className={classNames(
                  'ui-open:rotate-180 ui-open:transform',
                  'text-purple-500 h-5 w-5',
                  open ? 'rotate-180 transform' : '',
                )}
              />
            </div>
          </Disclosure.Button>
          <Disclosure.Panel>{children}</Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
};

export default CollapseableContainer;
